import { useRequiredContext } from "@redotech/react-util/context";
import { EffectApiClientContext } from "@redotech/redo-merchant-app-common/effect-api-client-provider";
import { useQuery } from "@tanstack/react-query";
import { catchApiErrors } from "../db/error-handling";

export const macroKeys = {
  all: ["macros"] as const,
  list: () => [...macroKeys.all, "list"] as const,
};

/**
 * Hook to fetch macros lazily. Pass `enabled: true` to trigger the fetch.
 * By default, macros are not fetched until enabled.
 */
export function useMacros(options?: { enabled?: boolean }) {
  const effectApi = useRequiredContext(EffectApiClientContext);
  const enabled = options?.enabled ?? false;

  const query = useQuery({
    queryKey: macroKeys.list(),
    queryFn: async () => {
      const client = effectApi.getClient();
      return await effectApi.runPromise(
        catchApiErrors(client.macro.getMacros()),
      );
    },
    staleTime: 30_000,
    enabled,
  });

  return {
    macros: query.data?.macros,
    isLoading: query.isLoading,
    refetch: query.refetch,
  };
}
